import store from '../store'
import camelCase from 'camelcase'

export default class DomWrangler {
  constructor () {
    this.update()
  }

  update () {
    const nodeList = document.querySelectorAll('[class*="js-"]')
    for (let i = 0; i < nodeList.length; i++) {
      store.dom[this.formatName(nodeList[i].className)] = nodeList[i]
    }
  }

  formatName (s) {
    // eslint-disable-next-line no-useless-escape
    return camelCase(s.match(/\js-(\S+)/)[1])
  }
}
